import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DirectionData,
  Paises,
  TiposDocumentoKosmos,
  TiposVia,
} from '../../../types/PersonalData';
import { MisDatosService } from '../../../services';
import useAPIError from '../../../hooks/useAPIError';
import FacturacionEmpresaForm from './facturacionEmpresaForm';
import FacturacionParticularForm from './facturacionParticularForm';
import DataService from '../../../services/MisDatosService';
import { DirectionsHelper } from '../DirectionsHelper';
import { MisDatosConstants } from '../../../utils/MisDatosConstants';
import IconBack from '../../../Icons/IconBack';

interface Props {
  directionData: DirectionData;
  isAdd: boolean;
  cargarDirecciones: () => void;
  tiposVia: TiposVia[];
}

const FacturacionForm: FC<Props> = (props) => {
  const { directionData, isAdd, cargarDirecciones, tiposVia } = props;
  const { t } = useTranslation();
  const { addError, addErrorBack } = useAPIError();
  const [isParticular, setIsParticular] = useState(false as boolean);
  const tipo = 'facturación';
  const [visible, setVisible] = useState(false as boolean);
  const [tempDirectionData, setTempDirectionData] = useState<DirectionData>(
    directionData,
  );
  const [tiposDocumentoActivos, setTiposDocumentoActivos] = useState<
    TiposDocumentoKosmos[]
  >([]);
  const [paises, setPaises] = useState<Paises[]>([]);
  const directionsHelper = new DirectionsHelper();

  let titulo;
  if (!isAdd) {
    titulo = `${t('datos.directions.dirBilling')}`;
  } else {
    titulo = `${t('datos.directions.newDirBilling')}`;
  }

  const hideForm = () => {
    directionsHelper.reiniciarFormularioDireccionFacturacion(directionData);
    setVisible(false);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    document
      .querySelector('section.bloque-form.visible')
      .classList.remove('visible');
    document.body.classList.remove('fix');
  };

  const HandleChange = (
    key: string,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'postalCode':
        setTempDirectionData({
          ...tempDirectionData,
          postalCode: e.target.value,
        });
        break;
      case 'roadName':
        setTempDirectionData({
          ...tempDirectionData,
          roadName: e.target.value,
        });
        break;
      case 'door':
        setTempDirectionData({
          ...tempDirectionData,
          door: e.target.value,
        });
        break;
      case 'floor':
        setTempDirectionData({
          ...tempDirectionData,
          floor: e.target.value,
        });
        break;
      case 'stairs':
        setTempDirectionData({
          ...tempDirectionData,
          stairs: e.target.value,
        });
        break;
      case 'number':
        setTempDirectionData({
          ...tempDirectionData,
          number: e.target.value,
        });
        break;
      case 'portal':
        setTempDirectionData({
          ...tempDirectionData,
          portal: e.target.value,
        });
        break;
      case 'directionName':
        setTempDirectionData({
          ...tempDirectionData,
          directionName: e.target.value,
        });
        break;
      case 'razonSocial':
        setTempDirectionData({
          ...tempDirectionData,
          razonSocial: e.target.value,
        });
        break;
      case 'cif':
        setTempDirectionData({
          ...tempDirectionData,
          cif: e.target.value,
        });
        break;
      case 'nombre':
        setTempDirectionData({
          ...tempDirectionData,
          nombre: e.target.value,
        });
        break;
      case 'primApellido':
        setTempDirectionData({
          ...tempDirectionData,
          apellido1: e.target.value,
        });
        break;
      case 'segApellido':
        setTempDirectionData({
          ...tempDirectionData,
          apellido2: e.target.value,
        });
        break;
      case 'ci':
        setTempDirectionData({
          ...tempDirectionData,
          numDoc: e.target.value,
        });
        break;
      case 'localidad':
        setTempDirectionData({
          ...tempDirectionData,
          locality: e.target.value,
        });
        break;
    }
  };

  const HandleChangeSelect = (
    key: string,
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'tipoDocKosmos':
        setTempDirectionData({
          ...tempDirectionData,
          tipoDocKosmos: e.target.value,
        });
        break;
      case 'pais':
        setTempDirectionData({
          ...tempDirectionData,
          country: e.target.value,
        });
        break;
      case 'tipoVia':
        // eslint-disable-next-line no-case-declarations
        const index = e.target.selectedIndex;
        setTempDirectionData({
          ...tempDirectionData,
          roadType: e.target.value,
          roadTypeDesc: e.target[index].innerText,
        });
        break;
    }
  };

  const UpdateDireccion = () => {
    tempDirectionData.tipoDireccion = MisDatosConstants.ID_TIPO_FACTURACION;
    if (!isParticular) {
      tempDirectionData.tipoDocKosmos = MisDatosConstants.TIPO_DOC_CIF_KOSMOS;
    }
    if (tempDirectionData.country === '') {
      tempDirectionData.country = 'es';
    }
    MisDatosService.updateDireccion(tempDirectionData)
      .then((response) => {
        if (response.data.error === true) {
          addErrorBack(response.data);
        } else {
          // hideForm();
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          document.getElementById(`${tipo}-back`).click();
          cargarDirecciones();
        }
      })
      .catch((er) => {
        console.log(er);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  const manageProvinceByCP = (postalCode: string, id: string) => {
    const expRegCodPos = new RegExp(
      /^(?:0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-2])([0-9]{3})$/,
    );
    const data = {
      codigoPostal: postalCode,
    };
    const provinceInput = document.getElementById(id) as HTMLInputElement;
    if (expRegCodPos.test(data.codigoPostal)) {
      DataService.getProvinciaByCodigoPostal(data)
        .then((response) => {
          if (response.data.error === true) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
          } else {
            if (provinceInput) {
              provinceInput.value = response.data.pojo.provincia;
            }
            setTempDirectionData({
              ...tempDirectionData,
              province: response.data.pojo.provincia,
              postalCode: data.codigoPostal,
            });
          }
        })
        .catch((er: any) => {
          console.log(er);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        });
    }
  };

  const retrievePaises = () => {
    DataService.getPaisesParaDirecciones()
      .then((response) => {
        if (response.data.error === true) {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        } else if (typeof response.data.pojos !== 'undefined') {
          setPaises(response.data.pojos);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  const retrieveDocumentosKosmos = () => {
    DataService.getTiposDocumentoKosmos()
      .then((response) => {
        if (response.data.error === true) {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        } else if (typeof response.data.pojos !== 'undefined') {
          setTiposDocumentoActivos(response.data.pojos);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  useEffect(() => {
    if (!isAdd) {
      setVisible(true);
      if (
        tempDirectionData.tipoDireccion === 2 &&
        tempDirectionData.razonSocial !== null
      ) {
        setIsParticular(false);
      } else {
        setIsParticular(true);
      }
    }
    retrieveDocumentosKosmos();
    retrievePaises();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdd]);

  return (
    <>
      <section
        id={!isAdd ? `${tipo}-${directionData.idDireccion}` : 'new-facturacion'}
        className="o-section--large form-facturacion bloque-form"
      >
        <div className="container">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <a
            id={`${tipo}-back`}
            href={`#${tipo}`}
            onClick={() => {
              hideForm();
            }}
            className="link-prev"
          >
            <div className="icon icon-medium">
              <IconBack />
            </div>
            <p className="u-font-normal u-text-brand u-margin-left">
              {t('datos.directions.back')}
            </p>
          </a>
          <h2 className="bloque-datos__title u-text-brand">
            <span className="divider__square brand-color" />
            <span className="u-margin-right">{titulo}</span>
          </h2>
          {isAdd ? (
            <div className="u-margin-bottom-large">
              <p className="control-label u-margin-bottom">
                {t('datos.directions.userType')}
              </p>
              <div className="radio radio-inline">
                <input
                  type="radio"
                  id={`particular-${directionData.idDireccion}`}
                  value="particular"
                  name="usuario-tipo"
                  className="form-control"
                  onClick={() => {
                    setIsParticular(true);
                    setVisible(true);
                  }}
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="particular" className="control-label">
                  {t('datos.directions.particular')}
                </label>
              </div>
              <div className="radio radio-inline">
                <input
                  type="radio"
                  id={`empresa-${directionData.idDireccion}`}
                  value="empresa"
                  name="usuario-tipo"
                  className="form-control"
                  onClick={() => {
                    setIsParticular(false);
                    setVisible(true);
                  }}
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="empresa" className="control-label">
                  {t('datos.directions.enterprise')}
                </label>
              </div>
            </div>
          ) : (
            ''
          )}
          {(() => {
            if (visible || !isAdd) {
              return (
                <>
                  <FacturacionParticularForm
                    directionData={directionData}
                    isParticular={isParticular}
                    updateDireccion={UpdateDireccion}
                    handleChange={HandleChange}
                    handleChangeSelect={HandleChangeSelect}
                    tiposDocumento={tiposDocumentoActivos}
                    paises={paises}
                    tiposVia={tiposVia}
                    manageProvinceByCP={manageProvinceByCP}
                    isAdd={isAdd}
                  />
                  <FacturacionEmpresaForm
                    directionData={directionData}
                    tempDirectionData={tempDirectionData}
                    setTempDirectiondata={setTempDirectionData}
                    isParticular={isParticular}
                    updateDireccion={UpdateDireccion}
                    handleChange={HandleChange}
                    handleChangeSelect={HandleChangeSelect}
                    tiposVia={tiposVia}
                    manageProvinceByCP={manageProvinceByCP}
                    isAdd={isAdd}
                  />
                </>
              );
            }
            return false;
          })()}
        </div>
      </section>
    </>
  );
};

export default FacturacionForm;
